<template>
  <div :class="['drinks-menu-footer',{selected:selected},{'togo-footer':isTogoMenu}]">
    <div class="footer-inner">
      <div v-if="!isTogoMenu" class="footer-logo">
        <img
          class="footer-logo-img"
          src="../../../static/satsuma-horiz-logo-black.svg"
          alt="Satsuma Café"
        >
      </div>
      <div v-if="!isTogoMenu" class="footer-text">
        <editable-text
          tag="p"
          :key="`${timestamp}_blurb`"
          v-if="location.acf.location_menu_blurb"
          :content="location.acf.location_menu_blurb"
          :editable="isEditable"
          @update="location.acf.location_menu_blurb = $event"
        />
      </div>
      <div v-if="!isTogoMenu" class="footer-meta">
        <div class="address">
          <div class="address-elem">
            <editable-text
              tag="div"
              :key="`${timestamp}_ad1`"
              :content="location.acf.location_address1"
              :editable="isEditable"
              @update="location.acf.location_address1 = $event"
            />
          </div>
          <div class="address-elem">
            <editable-text
              tag="div"
              :key="`${timestamp}_city`"
              :content="location.acf.location_city"
              :editable="isEditable"
              @update="location.acf.location_city = $event"
            />
            <span>,</span>
            <editable-text
              tag="div"
              :key="`${timestamp}_state`"
              :content="location.acf.location_state"
              :editable="isEditable"
              @update="location.acf.location_state = $event"
            />
          </div>
        </div>
        <editable-text
          tag="div"
          class="phone"
          v-if="location.acf.location_phone"
          :key="`${timestamp}_phone`"
          :content="location.acf.location_phone"
          :editable="isEditable"
          @update="location.acf.location_phone = $event"
        />
        <editable-text
          tag="div"
          class="hours"
          v-if="location.acf.location_hours"
          :key="`${timestamp}_hours`"
          :content="location.acf.location_hours"
          :editable="isEditable"
          @update="location.acf.location_hours = $event"
        />
      </div>
      <DrinksFooterMeta v-else/>
    </div>
    <transition name="fade">
      <button-cluster
        v-if="selected"
        :class="'menu-button-cluster'"
        :buttons="buttons"
        :item="location"
        bottomCenter
      />
    </transition>
  </div>
  <!-- /menu footer -->
</template>

<script>
import axios from "axios";

import EditableTextField from "../EditableTextField";
import ButtonCluster from "../UI/ButtonCluster";
import DrinksFooterMeta from "./DrinksFooterMeta";

import ToggleSelect from "../../toggle-select";
import VueClickaway from "vue-clickaway";

import _cloneDeep from "lodash/cloneDeep";
import _isEqual from "lodash/isEqual";

import { mapState } from "vuex";

export default {
  name: "DrinksMenuFooter",

  props: {
    location: Object,
    selected: Boolean
  },

  // mixins : [ VueClickaway.mixin, ToggleSelect ],

  components: {
    "editable-text": EditableTextField,
    "button-cluster": ButtonCluster,
    DrinksFooterMeta
  },

  data() {
    return {
      originalObj: {},
      buttons: [
        {
          title: "Clear Changes",
          icon: "undo",
          // iconOnly : true,
          clickHandler: this.clearChanges,
          conditional: () => {
            return this.hasChanges;
          }
        },
        {
          title: "Save Location",
          icon: "save",
          // iconOnly : true,
          clickHandler: this.saveLocation
        }
      ]
    };
  },

  computed: {
    ...mapState(["wpData", "authToken", "hideGlobalUI"]),
    isEditable() {
      return !this.disabled && !this.hideGlobalUI;
    },
    hasChanges() {
      return !_isEqual(this.originalObj, this.location);
    },
    isTogoMenu() {
      return parseInt(this.wpData.togo);
    } // isTogoMenu
  },

  methods: {
    saveLocation() {
      let location_id = this.location.id;

      this.$notify({ text: "Saving Location info...", duration: -1 });

      this.$store.dispatch("authPromise").then(authToken => {
        let acfFields = { fields: this.location.acf };
        return axios
          .put(
            `${this.wpData.rest_url}/acf/v3/${
              this.wpData.cpts.locations
            }/${location_id}`,
            acfFields,
            { headers: { Authorization: `Bearer ${this.authToken}` } }
          )
          .then(res => {
            this.$notify({ clean: true });
            this.$notify({ text: "Location saved!", type: "success" });
            console.log(`[ACF Updated for ${location_id}]`, res);
            return res;
          })
          .catch(err => {
            this.$notify({ clean: true });
            this.$notify({
              text: "Error: Could not save location.",
              type: "warn"
            });
            console.log(`[ACF Error for ${location_id}]`, err.message);
          });
      });
    }, // saveLocation()
    clearChanges() {
      let payload = {
        acfObj: _cloneDeep(this.originalObj.acf),
        loc_id: this.location.id
      };
      this.$store.commit("setLocationAcf", payload);
      this.timestamp = Date.now();
    } // clearChanges
  }, // methods

  created() {
    this.timestamp = Date.now();
    this.originalObj = _cloneDeep(this.location);
  }
};
</script>
<style lang="scss">
$gutter: 20px;

.drinks-menu-footer {
  border-top: 2px solid black;
  width: 100% * (22/24);
  margin: auto;
  padding: $gutter * 2 0;

  @media (max-width: 1254px) {
    width: 100%;
  }
  &:not(.togo-footer) {
    @media (max-width: 999px) {
      display: none;
    }
  }

  &.selected {
    > .button-cluster {
      display: flex;
    }
  }

  $mq: 1024px;

  .footer-inner {
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
  }
  .footer-logo {
    padding: $gutter 0;
    margin-left: 100% * (1/24);
    flex: 0 0 (100% * (6/24));
    @media (max-width: $mq) {
      display: none;
    }
  }
  .footer-text {
    font-style: italic;
    margin-left: 100% * (1/24);
    flex: 0 0 (100% * (10/24));
    strong {
      font-size: 1.1em;
    }

    @media (max-width: $mq) {
      margin-left: 0;
      flex: 0 0 100%;
    }
  }
  .footer-meta {
    margin-left: 100% * (1/24);
    flex: 0 0 (100% * (5/24));
    font-size: 1.2rem;

    @media (max-width: $mq) {
      margin-left: 0;
      flex: 0 0 100%;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
    }

    > * {
      margin-bottom: 1em;
      @media (max-width: $mq) {
        // margin-left:0;
        flex: 1 0 180px;
      }
    }
    .address,
    .hours,
    .website {
      font-weight: bold;
    }
    .empty-text {
      height: 1em;
      background-color: darken(white, 6%);
      width: 100%;
    }
    .address {
      .address-elem * {
        display: inline-block;
      }
    }

    &.togo-meta {
      flex-basis: 100%;
      margin: 0;
      text-align: left;
      .locations-wrap {
        display: flex;
        justify-content: space-between;
        .location-meta {
          margin-top: 35px;
          flex: 1 1 50%;
          &.right {
            text-align: right;
          }
          &.center {
            text-align: center;
          }
          .location-name {
            margin: 0.3em 0;
          }
          p {
            margin: 0;
            line-height: 1.25;
          }
        }
      }
      .hours-and-website-wrap {
        margin-top: 20px;
        display: flex;
        flex-basis: 100%;
        .hours,
        .website {
          font-size: 1.1rem;
          flex: 1 1 50%;
        }
        .website {
          text-align: right;
        }
      }
      p {
        padding-bottom: 0;
      }
    } // &.togo-meta
  } // .footer-meta
} // .drinks-menu-footer
</style>


// WEBPACK FOOTER //
// src/components/Menus/DrinksMenuFooter.vue